var _toArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toArray.js");

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _toConsumableArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _wrapNativeSuper = require("/vercel/path0/node_modules/@babel/runtime/helpers/wrapNativeSuper.js");

var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

require("core-js/modules/esnext.global-this.js");

/**
  * This file contains the Bottleneck library (MIT), compiled to ES2017, and without Clustering support.
  * https://github.com/SGrondin/bottleneck
  */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Bottleneck = factory();
})(this, function () {
  'use strict';

  var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

  function getCjsExportFromNamespace(n) {
    return n && n['default'] || n;
  }

  var load = function load(received, defaults) {
    var onto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var k, ref, v;

    for (k in defaults) {
      v = defaults[k];
      onto[k] = (ref = received[k]) != null ? ref : v;
    }

    return onto;
  };

  var overwrite = function overwrite(received, defaults) {
    var onto = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var k, v;

    for (k in received) {
      v = received[k];

      if (defaults[k] !== void 0) {
        onto[k] = v;
      }
    }

    return onto;
  };

  var parser = {
    load: load,
    overwrite: overwrite
  };
  var DLList;

  DLList = /*#__PURE__*/function () {
    function DLList(incr, decr) {
      _classCallCheck(this, DLList);

      this.incr = incr;
      this.decr = decr;
      this._first = null;
      this._last = null;
      this.length = 0;
    }

    _createClass(DLList, [{
      key: "push",
      value: function push(value) {
        var node;
        this.length++;

        if (typeof this.incr === "function") {
          this.incr();
        }

        node = {
          value: value,
          prev: this._last,
          next: null
        };

        if (this._last != null) {
          this._last.next = node;
          this._last = node;
        } else {
          this._first = this._last = node;
        }

        return void 0;
      }
    }, {
      key: "shift",
      value: function shift() {
        var value;

        if (this._first == null) {
          return;
        } else {
          this.length--;

          if (typeof this.decr === "function") {
            this.decr();
          }
        }

        value = this._first.value;

        if ((this._first = this._first.next) != null) {
          this._first.prev = null;
        } else {
          this._last = null;
        }

        return value;
      }
    }, {
      key: "first",
      value: function first() {
        if (this._first != null) {
          return this._first.value;
        }
      }
    }, {
      key: "getArray",
      value: function getArray() {
        var node, ref, results;
        node = this._first;
        results = [];

        while (node != null) {
          results.push((ref = node, node = node.next, ref.value));
        }

        return results;
      }
    }, {
      key: "forEachShift",
      value: function forEachShift(cb) {
        var node;
        node = this.shift();

        while (node != null) {
          cb(node), node = this.shift();
        }

        return void 0;
      }
    }, {
      key: "debug",
      value: function debug() {
        var node, ref, ref1, ref2, results;
        node = this._first;
        results = [];

        while (node != null) {
          results.push((ref = node, node = node.next, {
            value: ref.value,
            prev: (ref1 = ref.prev) != null ? ref1.value : void 0,
            next: (ref2 = ref.next) != null ? ref2.value : void 0
          }));
        }

        return results;
      }
    }]);

    return DLList;
  }();

  var DLList_1 = DLList;
  var Events;

  Events = /*#__PURE__*/function () {
    function Events(instance) {
      var _this = this;

      _classCallCheck(this, Events);

      this.instance = instance;
      this._events = {};

      if (this.instance.on != null || this.instance.once != null || this.instance.removeAllListeners != null) {
        throw new Error("An Emitter already exists for this object");
      }

      this.instance.on = function (name, cb) {
        return _this._addListener(name, "many", cb);
      };

      this.instance.once = function (name, cb) {
        return _this._addListener(name, "once", cb);
      };

      this.instance.removeAllListeners = function () {
        var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (name != null) {
          return delete _this._events[name];
        } else {
          return _this._events = {};
        }
      };
    }

    _createClass(Events, [{
      key: "_addListener",
      value: function _addListener(name, status, cb) {
        var base;

        if ((base = this._events)[name] == null) {
          base[name] = [];
        }

        this._events[name].push({
          cb: cb,
          status: status
        });

        return this.instance;
      }
    }, {
      key: "listenerCount",
      value: function listenerCount(name) {
        if (this._events[name] != null) {
          return this._events[name].length;
        } else {
          return 0;
        }
      }
    }, {
      key: "trigger",
      value: function () {
        var _trigger = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(name) {
          var _this2 = this;

          var _len,
              args,
              _key,
              e,
              promises,
              _args2 = arguments;

          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  for (_len = _args2.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    args[_key - 1] = _args2[_key];
                  }

                  _context2.prev = 1;

                  if (name !== "debug") {
                    this.trigger("debug", "Event triggered: ".concat(name), args);
                  }

                  if (!(this._events[name] == null)) {
                    _context2.next = 5;
                    break;
                  }

                  return _context2.abrupt("return");

                case 5:
                  this._events[name] = this._events[name].filter(function (listener) {
                    return listener.status !== "none";
                  });
                  promises = this._events[name].map( /*#__PURE__*/function () {
                    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(listener) {
                      var e, returned;
                      return _regeneratorRuntime.wrap(function _callee$(_context) {
                        while (1) {
                          switch (_context.prev = _context.next) {
                            case 0:
                              if (!(listener.status === "none")) {
                                _context.next = 2;
                                break;
                              }

                              return _context.abrupt("return");

                            case 2:
                              if (listener.status === "once") {
                                listener.status = "none";
                              }

                              _context.prev = 3;
                              returned = typeof listener.cb === "function" ? listener.cb.apply(listener, args) : void 0;

                              if (!(typeof (returned != null ? returned.then : void 0) === "function")) {
                                _context.next = 11;
                                break;
                              }

                              _context.next = 8;
                              return returned;

                            case 8:
                              return _context.abrupt("return", _context.sent);

                            case 11:
                              return _context.abrupt("return", returned);

                            case 12:
                              _context.next = 19;
                              break;

                            case 14:
                              _context.prev = 14;
                              _context.t0 = _context["catch"](3);
                              e = _context.t0;

                              _this2.trigger("error", e);

                              return _context.abrupt("return", null);

                            case 19:
                            case "end":
                              return _context.stop();
                          }
                        }
                      }, _callee, null, [[3, 14]]);
                    }));

                    return function (_x2) {
                      return _ref.apply(this, arguments);
                    };
                  }());
                  _context2.next = 9;
                  return Promise.all(promises);

                case 9:
                  return _context2.abrupt("return", _context2.sent.find(function (x) {
                    return x != null;
                  }));

                case 12:
                  _context2.prev = 12;
                  _context2.t0 = _context2["catch"](1);
                  e = _context2.t0;
                  this.trigger("error", e);
                  return _context2.abrupt("return", null);

                case 17:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2, this, [[1, 12]]);
        }));

        function trigger(_x) {
          return _trigger.apply(this, arguments);
        }

        return trigger;
      }()
    }]);

    return Events;
  }();

  var Events_1 = Events;
  var DLList$1, Events$1, Queues;
  DLList$1 = DLList_1;
  Events$1 = Events_1;

  Queues = /*#__PURE__*/function () {
    function Queues(num_priorities) {
      _classCallCheck(this, Queues);

      var i;
      this.Events = new Events$1(this);
      this._length = 0;

      this._lists = function () {
        var _this3 = this;

        var j, ref, results;
        results = [];

        for (i = j = 1, ref = num_priorities; 1 <= ref ? j <= ref : j >= ref; i = 1 <= ref ? ++j : --j) {
          results.push(new DLList$1(function () {
            return _this3.incr();
          }, function () {
            return _this3.decr();
          }));
        }

        return results;
      }.call(this);
    }

    _createClass(Queues, [{
      key: "incr",
      value: function incr() {
        if (this._length++ === 0) {
          return this.Events.trigger("leftzero");
        }
      }
    }, {
      key: "decr",
      value: function decr() {
        if (--this._length === 0) {
          return this.Events.trigger("zero");
        }
      }
    }, {
      key: "push",
      value: function push(job) {
        return this._lists[job.options.priority].push(job);
      }
    }, {
      key: "queued",
      value: function queued(priority) {
        if (priority != null) {
          return this._lists[priority].length;
        } else {
          return this._length;
        }
      }
    }, {
      key: "shiftAll",
      value: function shiftAll(fn) {
        return this._lists.forEach(function (list) {
          return list.forEachShift(fn);
        });
      }
    }, {
      key: "getFirst",
      value: function getFirst() {
        var arr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._lists;
        var j, len, list;

        for (j = 0, len = arr.length; j < len; j++) {
          list = arr[j];

          if (list.length > 0) {
            return list;
          }
        }

        return [];
      }
    }, {
      key: "shiftLastFrom",
      value: function shiftLastFrom(priority) {
        return this.getFirst(this._lists.slice(priority).reverse()).shift();
      }
    }]);

    return Queues;
  }();

  var Queues_1 = Queues;
  var BottleneckError;

  BottleneckError = /*#__PURE__*/function (_Error) {
    _inherits(BottleneckError, _Error);

    var _super = _createSuper(BottleneckError);

    function BottleneckError() {
      _classCallCheck(this, BottleneckError);

      return _super.apply(this, arguments);
    }

    return _createClass(BottleneckError);
  }( /*#__PURE__*/_wrapNativeSuper(Error));

  var BottleneckError_1 = BottleneckError;
  var BottleneckError$1, DEFAULT_PRIORITY, Job, NUM_PRIORITIES, parser$1;
  NUM_PRIORITIES = 10;
  DEFAULT_PRIORITY = 5;
  parser$1 = parser;
  BottleneckError$1 = BottleneckError_1;

  Job = /*#__PURE__*/function () {
    function Job(task, args, options, jobDefaults, rejectOnDrop, Events, _states, Promise) {
      var _this4 = this;

      _classCallCheck(this, Job);

      this.task = task;
      this.args = args;
      this.rejectOnDrop = rejectOnDrop;
      this.Events = Events;
      this._states = _states;
      this.Promise = Promise;
      this.options = parser$1.load(options, jobDefaults);
      this.options.priority = this._sanitizePriority(this.options.priority);

      if (this.options.id === jobDefaults.id) {
        this.options.id = "".concat(this.options.id, "-").concat(this._randomIndex());
      }

      this.promise = new this.Promise(function (_resolve, _reject) {
        _this4._resolve = _resolve;
        _this4._reject = _reject;
      });
      this.retryCount = 0;
    }

    _createClass(Job, [{
      key: "_sanitizePriority",
      value: function _sanitizePriority(priority) {
        var sProperty;
        sProperty = ~~priority !== priority ? DEFAULT_PRIORITY : priority;

        if (sProperty < 0) {
          return 0;
        } else if (sProperty > NUM_PRIORITIES - 1) {
          return NUM_PRIORITIES - 1;
        } else {
          return sProperty;
        }
      }
    }, {
      key: "_randomIndex",
      value: function _randomIndex() {
        return Math.random().toString(36).slice(2);
      }
    }, {
      key: "doDrop",
      value: function doDrop() {
        var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
            error = _ref2.error,
            _ref2$message = _ref2.message,
            message = _ref2$message === void 0 ? "This job has been dropped by Bottleneck" : _ref2$message;

        if (this._states.remove(this.options.id)) {
          if (this.rejectOnDrop) {
            this._reject(error != null ? error : new BottleneckError$1(message));
          }

          this.Events.trigger("dropped", {
            args: this.args,
            options: this.options,
            task: this.task,
            promise: this.promise
          });
          return true;
        } else {
          return false;
        }
      }
    }, {
      key: "_assertStatus",
      value: function _assertStatus(expected) {
        var status;
        status = this._states.jobStatus(this.options.id);

        if (!(status === expected || expected === "DONE" && status === null)) {
          throw new BottleneckError$1("Invalid job status ".concat(status, ", expected ").concat(expected, ". Please open an issue at https://github.com/SGrondin/bottleneck/issues"));
        }
      }
    }, {
      key: "doReceive",
      value: function doReceive() {
        this._states.start(this.options.id);

        return this.Events.trigger("received", {
          args: this.args,
          options: this.options
        });
      }
    }, {
      key: "doQueue",
      value: function doQueue(reachedHWM, blocked) {
        this._assertStatus("RECEIVED");

        this._states.next(this.options.id);

        return this.Events.trigger("queued", {
          args: this.args,
          options: this.options,
          reachedHWM: reachedHWM,
          blocked: blocked
        });
      }
    }, {
      key: "doRun",
      value: function doRun() {
        if (this.retryCount === 0) {
          this._assertStatus("QUEUED");

          this._states.next(this.options.id);
        } else {
          this._assertStatus("EXECUTING");
        }

        return this.Events.trigger("scheduled", {
          args: this.args,
          options: this.options
        });
      }
    }, {
      key: "doExecute",
      value: function () {
        var _doExecute = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(chained, clearGlobalState, run, free) {
          var error, eventInfo, passed;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  if (this.retryCount === 0) {
                    this._assertStatus("RUNNING");

                    this._states.next(this.options.id);
                  } else {
                    this._assertStatus("EXECUTING");
                  }

                  eventInfo = {
                    args: this.args,
                    options: this.options,
                    retryCount: this.retryCount
                  };
                  this.Events.trigger("executing", eventInfo);
                  _context3.prev = 3;
                  _context3.next = 6;
                  return chained != null ? chained.schedule.apply(chained, [this.options, this.task].concat(_toConsumableArray(this.args))) : this.task.apply(this, _toConsumableArray(this.args));

                case 6:
                  passed = _context3.sent;

                  if (!clearGlobalState()) {
                    _context3.next = 13;
                    break;
                  }

                  this.doDone(eventInfo);
                  _context3.next = 11;
                  return free(this.options, eventInfo);

                case 11:
                  this._assertStatus("DONE");

                  return _context3.abrupt("return", this._resolve(passed));

                case 13:
                  _context3.next = 19;
                  break;

                case 15:
                  _context3.prev = 15;
                  _context3.t0 = _context3["catch"](3);
                  error = _context3.t0;
                  return _context3.abrupt("return", this._onFailure(error, eventInfo, clearGlobalState, run, free));

                case 19:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3, this, [[3, 15]]);
        }));

        function doExecute(_x3, _x4, _x5, _x6) {
          return _doExecute.apply(this, arguments);
        }

        return doExecute;
      }()
    }, {
      key: "doExpire",
      value: function doExpire(clearGlobalState, run, free) {
        var error, eventInfo;

        if (this._states.jobStatus(this.options.id === "RUNNING")) {
          this._states.next(this.options.id);
        }

        this._assertStatus("EXECUTING");

        eventInfo = {
          args: this.args,
          options: this.options,
          retryCount: this.retryCount
        };
        error = new BottleneckError$1("This job timed out after ".concat(this.options.expiration, " ms."));
        return this._onFailure(error, eventInfo, clearGlobalState, run, free);
      }
    }, {
      key: "_onFailure",
      value: function () {
        var _onFailure2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(error, eventInfo, clearGlobalState, run, free) {
          var retry, retryAfter;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  if (!clearGlobalState()) {
                    _context4.next = 16;
                    break;
                  }

                  _context4.next = 3;
                  return this.Events.trigger("failed", error, eventInfo);

                case 3:
                  retry = _context4.sent;

                  if (!(retry != null)) {
                    _context4.next = 11;
                    break;
                  }

                  retryAfter = ~~retry;
                  this.Events.trigger("retry", "Retrying ".concat(this.options.id, " after ").concat(retryAfter, " ms"), eventInfo);
                  this.retryCount++;
                  return _context4.abrupt("return", run(retryAfter));

                case 11:
                  this.doDone(eventInfo);
                  _context4.next = 14;
                  return free(this.options, eventInfo);

                case 14:
                  this._assertStatus("DONE");

                  return _context4.abrupt("return", this._reject(error));

                case 16:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function _onFailure(_x7, _x8, _x9, _x10, _x11) {
          return _onFailure2.apply(this, arguments);
        }

        return _onFailure;
      }()
    }, {
      key: "doDone",
      value: function doDone(eventInfo) {
        this._assertStatus("EXECUTING");

        this._states.next(this.options.id);

        return this.Events.trigger("done", eventInfo);
      }
    }]);

    return Job;
  }();

  var Job_1 = Job;
  var BottleneckError$2, LocalDatastore, parser$2;
  parser$2 = parser;
  BottleneckError$2 = BottleneckError_1;

  LocalDatastore = /*#__PURE__*/function () {
    function LocalDatastore(instance, storeOptions, storeInstanceOptions) {
      _classCallCheck(this, LocalDatastore);

      this.instance = instance;
      this.storeOptions = storeOptions;
      this.clientId = this.instance._randomIndex();
      parser$2.load(storeInstanceOptions, storeInstanceOptions, this);
      this._nextRequest = this._lastReservoirRefresh = this._lastReservoirIncrease = Date.now();
      this._running = 0;
      this._done = 0;
      this._unblockTime = 0;
      this.ready = this.Promise.resolve();
      this.clients = {};

      this._startHeartbeat();
    }

    _createClass(LocalDatastore, [{
      key: "_startHeartbeat",
      value: function _startHeartbeat() {
        var _this5 = this;

        var base;

        if (this.heartbeat == null && (this.storeOptions.reservoirRefreshInterval != null && this.storeOptions.reservoirRefreshAmount != null || this.storeOptions.reservoirIncreaseInterval != null && this.storeOptions.reservoirIncreaseAmount != null)) {
          return typeof (base = this.heartbeat = setInterval(function () {
            var amount, incr, maximum, now, reservoir;
            now = Date.now();

            if (_this5.storeOptions.reservoirRefreshInterval != null && now >= _this5._lastReservoirRefresh + _this5.storeOptions.reservoirRefreshInterval) {
              _this5._lastReservoirRefresh = now;
              _this5.storeOptions.reservoir = _this5.storeOptions.reservoirRefreshAmount;

              _this5.instance._drainAll(_this5.computeCapacity());
            }

            if (_this5.storeOptions.reservoirIncreaseInterval != null && now >= _this5._lastReservoirIncrease + _this5.storeOptions.reservoirIncreaseInterval) {
              var _this5$storeOptions = _this5.storeOptions;
              amount = _this5$storeOptions.reservoirIncreaseAmount;
              maximum = _this5$storeOptions.reservoirIncreaseMaximum;
              reservoir = _this5$storeOptions.reservoir;
              _this5._lastReservoirIncrease = now;
              incr = maximum != null ? Math.min(amount, maximum - reservoir) : amount;

              if (incr > 0) {
                _this5.storeOptions.reservoir += incr;
                return _this5.instance._drainAll(_this5.computeCapacity());
              }
            }
          }, this.heartbeatInterval)).unref === "function" ? base.unref() : void 0;
        } else {
          return clearInterval(this.heartbeat);
        }
      }
    }, {
      key: "__publish__",
      value: function () {
        var _publish__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(message) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context5.abrupt("return", this.instance.Events.trigger("message", message.toString()));

                case 3:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5, this);
        }));

        function __publish__(_x12) {
          return _publish__.apply(this, arguments);
        }

        return __publish__;
      }()
    }, {
      key: "__disconnect__",
      value: function () {
        var _disconnect__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(flush) {
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _context6.next = 2;
                  return this.yieldLoop();

                case 2:
                  clearInterval(this.heartbeat);
                  return _context6.abrupt("return", this.Promise.resolve());

                case 4:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6, this);
        }));

        function __disconnect__(_x13) {
          return _disconnect__.apply(this, arguments);
        }

        return __disconnect__;
      }()
    }, {
      key: "yieldLoop",
      value: function yieldLoop() {
        var t = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        return new this.Promise(function (resolve, reject) {
          return setTimeout(resolve, t);
        });
      }
    }, {
      key: "computePenalty",
      value: function computePenalty() {
        var ref;
        return (ref = this.storeOptions.penalty) != null ? ref : 15 * this.storeOptions.minTime || 5000;
      }
    }, {
      key: "__updateSettings__",
      value: function () {
        var _updateSettings__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(options) {
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _context7.next = 2;
                  return this.yieldLoop();

                case 2:
                  parser$2.overwrite(options, options, this.storeOptions);

                  this._startHeartbeat();

                  this.instance._drainAll(this.computeCapacity());

                  return _context7.abrupt("return", true);

                case 6:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7, this);
        }));

        function __updateSettings__(_x14) {
          return _updateSettings__.apply(this, arguments);
        }

        return __updateSettings__;
      }()
    }, {
      key: "__running__",
      value: function () {
        var _running__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context8.abrupt("return", this._running);

                case 3:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8, this);
        }));

        function __running__() {
          return _running__.apply(this, arguments);
        }

        return __running__;
      }()
    }, {
      key: "__queued__",
      value: function () {
        var _queued__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
              switch (_context9.prev = _context9.next) {
                case 0:
                  _context9.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context9.abrupt("return", this.instance.queued());

                case 3:
                case "end":
                  return _context9.stop();
              }
            }
          }, _callee9, this);
        }));

        function __queued__() {
          return _queued__.apply(this, arguments);
        }

        return __queued__;
      }()
    }, {
      key: "__done__",
      value: function () {
        var _done__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
              switch (_context10.prev = _context10.next) {
                case 0:
                  _context10.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context10.abrupt("return", this._done);

                case 3:
                case "end":
                  return _context10.stop();
              }
            }
          }, _callee10, this);
        }));

        function __done__() {
          return _done__.apply(this, arguments);
        }

        return __done__;
      }()
    }, {
      key: "__groupCheck__",
      value: function () {
        var _groupCheck__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(time) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
              switch (_context11.prev = _context11.next) {
                case 0:
                  _context11.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context11.abrupt("return", this._nextRequest + this.timeout < time);

                case 3:
                case "end":
                  return _context11.stop();
              }
            }
          }, _callee11, this);
        }));

        function __groupCheck__(_x15) {
          return _groupCheck__.apply(this, arguments);
        }

        return __groupCheck__;
      }()
    }, {
      key: "computeCapacity",
      value: function computeCapacity() {
        var maxConcurrent, reservoir;
        var _this$storeOptions = this.storeOptions;
        maxConcurrent = _this$storeOptions.maxConcurrent;
        reservoir = _this$storeOptions.reservoir;

        if (maxConcurrent != null && reservoir != null) {
          return Math.min(maxConcurrent - this._running, reservoir);
        } else if (maxConcurrent != null) {
          return maxConcurrent - this._running;
        } else if (reservoir != null) {
          return reservoir;
        } else {
          return null;
        }
      }
    }, {
      key: "conditionsCheck",
      value: function conditionsCheck(weight) {
        var capacity;
        capacity = this.computeCapacity();
        return capacity == null || weight <= capacity;
      }
    }, {
      key: "__incrementReservoir__",
      value: function () {
        var _incrementReservoir__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(incr) {
          var reservoir;
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
              switch (_context12.prev = _context12.next) {
                case 0:
                  _context12.next = 2;
                  return this.yieldLoop();

                case 2:
                  reservoir = this.storeOptions.reservoir += incr;

                  this.instance._drainAll(this.computeCapacity());

                  return _context12.abrupt("return", reservoir);

                case 5:
                case "end":
                  return _context12.stop();
              }
            }
          }, _callee12, this);
        }));

        function __incrementReservoir__(_x16) {
          return _incrementReservoir__.apply(this, arguments);
        }

        return __incrementReservoir__;
      }()
    }, {
      key: "__currentReservoir__",
      value: function () {
        var _currentReservoir__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
          return _regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
              switch (_context13.prev = _context13.next) {
                case 0:
                  _context13.next = 2;
                  return this.yieldLoop();

                case 2:
                  return _context13.abrupt("return", this.storeOptions.reservoir);

                case 3:
                case "end":
                  return _context13.stop();
              }
            }
          }, _callee13, this);
        }));

        function __currentReservoir__() {
          return _currentReservoir__.apply(this, arguments);
        }

        return __currentReservoir__;
      }()
    }, {
      key: "isBlocked",
      value: function isBlocked(now) {
        return this._unblockTime >= now;
      }
    }, {
      key: "check",
      value: function check(weight, now) {
        return this.conditionsCheck(weight) && this._nextRequest - now <= 0;
      }
    }, {
      key: "__check__",
      value: function () {
        var _check__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(weight) {
          var now;
          return _regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
              switch (_context14.prev = _context14.next) {
                case 0:
                  _context14.next = 2;
                  return this.yieldLoop();

                case 2:
                  now = Date.now();
                  return _context14.abrupt("return", this.check(weight, now));

                case 4:
                case "end":
                  return _context14.stop();
              }
            }
          }, _callee14, this);
        }));

        function __check__(_x17) {
          return _check__.apply(this, arguments);
        }

        return __check__;
      }()
    }, {
      key: "__register__",
      value: function () {
        var _register__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(index, weight, expiration) {
          var now, wait;
          return _regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
              switch (_context15.prev = _context15.next) {
                case 0:
                  _context15.next = 2;
                  return this.yieldLoop();

                case 2:
                  now = Date.now();

                  if (!this.conditionsCheck(weight)) {
                    _context15.next = 11;
                    break;
                  }

                  this._running += weight;

                  if (this.storeOptions.reservoir != null) {
                    this.storeOptions.reservoir -= weight;
                  }

                  wait = Math.max(this._nextRequest - now, 0);
                  this._nextRequest = now + wait + this.storeOptions.minTime;
                  return _context15.abrupt("return", {
                    success: true,
                    wait: wait,
                    reservoir: this.storeOptions.reservoir
                  });

                case 11:
                  return _context15.abrupt("return", {
                    success: false
                  });

                case 12:
                case "end":
                  return _context15.stop();
              }
            }
          }, _callee15, this);
        }));

        function __register__(_x18, _x19, _x20) {
          return _register__.apply(this, arguments);
        }

        return __register__;
      }()
    }, {
      key: "strategyIsBlock",
      value: function strategyIsBlock() {
        return this.storeOptions.strategy === 3;
      }
    }, {
      key: "__submit__",
      value: function () {
        var _submit__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(queueLength, weight) {
          var blocked, now, reachedHWM;
          return _regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
              switch (_context16.prev = _context16.next) {
                case 0:
                  _context16.next = 2;
                  return this.yieldLoop();

                case 2:
                  if (!(this.storeOptions.maxConcurrent != null && weight > this.storeOptions.maxConcurrent)) {
                    _context16.next = 4;
                    break;
                  }

                  throw new BottleneckError$2("Impossible to add a job having a weight of ".concat(weight, " to a limiter having a maxConcurrent setting of ").concat(this.storeOptions.maxConcurrent));

                case 4:
                  now = Date.now();
                  reachedHWM = this.storeOptions.highWater != null && queueLength === this.storeOptions.highWater && !this.check(weight, now);
                  blocked = this.strategyIsBlock() && (reachedHWM || this.isBlocked(now));

                  if (blocked) {
                    this._unblockTime = now + this.computePenalty();
                    this._nextRequest = this._unblockTime + this.storeOptions.minTime;

                    this.instance._dropAllQueued();
                  }

                  return _context16.abrupt("return", {
                    reachedHWM: reachedHWM,
                    blocked: blocked,
                    strategy: this.storeOptions.strategy
                  });

                case 9:
                case "end":
                  return _context16.stop();
              }
            }
          }, _callee16, this);
        }));

        function __submit__(_x21, _x22) {
          return _submit__.apply(this, arguments);
        }

        return __submit__;
      }()
    }, {
      key: "__free__",
      value: function () {
        var _free__ = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(index, weight) {
          return _regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
              switch (_context17.prev = _context17.next) {
                case 0:
                  _context17.next = 2;
                  return this.yieldLoop();

                case 2:
                  this._running -= weight;
                  this._done += weight;

                  this.instance._drainAll(this.computeCapacity());

                  return _context17.abrupt("return", {
                    running: this._running
                  });

                case 6:
                case "end":
                  return _context17.stop();
              }
            }
          }, _callee17, this);
        }));

        function __free__(_x23, _x24) {
          return _free__.apply(this, arguments);
        }

        return __free__;
      }()
    }]);

    return LocalDatastore;
  }();

  var LocalDatastore_1 = LocalDatastore;
  var BottleneckError$3, States;
  BottleneckError$3 = BottleneckError_1;

  States = /*#__PURE__*/function () {
    function States(status1) {
      _classCallCheck(this, States);

      this.status = status1;
      this._jobs = {};
      this.counts = this.status.map(function () {
        return 0;
      });
    }

    _createClass(States, [{
      key: "next",
      value: function next(id) {
        var current, next;
        current = this._jobs[id];
        next = current + 1;

        if (current != null && next < this.status.length) {
          this.counts[current]--;
          this.counts[next]++;
          return this._jobs[id]++;
        } else if (current != null) {
          this.counts[current]--;
          return delete this._jobs[id];
        }
      }
    }, {
      key: "start",
      value: function start(id) {
        var initial;
        initial = 0;
        this._jobs[id] = initial;
        return this.counts[initial]++;
      }
    }, {
      key: "remove",
      value: function remove(id) {
        var current;
        current = this._jobs[id];

        if (current != null) {
          this.counts[current]--;
          delete this._jobs[id];
        }

        return current != null;
      }
    }, {
      key: "jobStatus",
      value: function jobStatus(id) {
        var ref;
        return (ref = this.status[this._jobs[id]]) != null ? ref : null;
      }
    }, {
      key: "statusJobs",
      value: function statusJobs(status) {
        var k, pos, ref, results, v;

        if (status != null) {
          pos = this.status.indexOf(status);

          if (pos < 0) {
            throw new BottleneckError$3("status must be one of ".concat(this.status.join(', ')));
          }

          ref = this._jobs;
          results = [];

          for (k in ref) {
            v = ref[k];

            if (v === pos) {
              results.push(k);
            }
          }

          return results;
        } else {
          return Object.keys(this._jobs);
        }
      }
    }, {
      key: "statusCounts",
      value: function statusCounts() {
        var _this6 = this;

        return this.counts.reduce(function (acc, v, i) {
          acc[_this6.status[i]] = v;
          return acc;
        }, {});
      }
    }]);

    return States;
  }();

  var States_1 = States;
  var DLList$2, Sync;
  DLList$2 = DLList_1;

  Sync = /*#__PURE__*/function () {
    function Sync(name, Promise) {
      _classCallCheck(this, Sync);

      this.schedule = this.schedule.bind(this);
      this.name = name;
      this.Promise = Promise;
      this._running = 0;
      this._queue = new DLList$2();
    }

    _createClass(Sync, [{
      key: "isEmpty",
      value: function isEmpty() {
        return this._queue.length === 0;
      }
    }, {
      key: "_tryToRun",
      value: function () {
        var _tryToRun2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
          var args, cb, error, reject, resolve, returned, task, _this$_queue$shift;

          return _regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
              switch (_context19.prev = _context19.next) {
                case 0:
                  if (!(this._running < 1 && this._queue.length > 0)) {
                    _context19.next = 13;
                    break;
                  }

                  this._running++;
                  _this$_queue$shift = this._queue.shift();
                  task = _this$_queue$shift.task;
                  args = _this$_queue$shift.args;
                  resolve = _this$_queue$shift.resolve;
                  reject = _this$_queue$shift.reject;
                  _context19.next = 9;
                  return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
                    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
                      while (1) {
                        switch (_context18.prev = _context18.next) {
                          case 0:
                            _context18.prev = 0;
                            _context18.next = 3;
                            return task.apply(void 0, _toConsumableArray(args));

                          case 3:
                            returned = _context18.sent;
                            return _context18.abrupt("return", function () {
                              return resolve(returned);
                            });

                          case 7:
                            _context18.prev = 7;
                            _context18.t0 = _context18["catch"](0);
                            error = _context18.t0;
                            return _context18.abrupt("return", function () {
                              return reject(error);
                            });

                          case 11:
                          case "end":
                            return _context18.stop();
                        }
                      }
                    }, _callee18, null, [[0, 7]]);
                  }))();

                case 9:
                  cb = _context19.sent;
                  this._running--;

                  this._tryToRun();

                  return _context19.abrupt("return", cb());

                case 13:
                case "end":
                  return _context19.stop();
              }
            }
          }, _callee19, this);
        }));

        function _tryToRun() {
          return _tryToRun2.apply(this, arguments);
        }

        return _tryToRun;
      }()
    }, {
      key: "schedule",
      value: function schedule(task) {
        var promise, reject, resolve;
        resolve = reject = null;
        promise = new this.Promise(function (_resolve, _reject) {
          resolve = _resolve;
          return reject = _reject;
        });

        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }

        this._queue.push({
          task: task,
          args: args,
          resolve: resolve,
          reject: reject
        });

        this._tryToRun();

        return promise;
      }
    }]);

    return Sync;
  }();

  var Sync_1 = Sync;
  var version = "2.19.5";
  var version$1 = {
    version: version
  };
  var version$2 = /*#__PURE__*/Object.freeze({
    version: version,
    default: version$1
  });

  var require$$2 = function require$$2() {
    return console.log('You must import the full version of Bottleneck in order to use this feature.');
  };

  var require$$3 = function require$$3() {
    return console.log('You must import the full version of Bottleneck in order to use this feature.');
  };

  var require$$4 = function require$$4() {
    return console.log('You must import the full version of Bottleneck in order to use this feature.');
  };

  var Events$2, Group, IORedisConnection$1, RedisConnection$1, Scripts$1, parser$3;
  parser$3 = parser;
  Events$2 = Events_1;
  RedisConnection$1 = require$$2;
  IORedisConnection$1 = require$$3;
  Scripts$1 = require$$4;

  Group = function () {
    var Group = /*#__PURE__*/function () {
      function Group() {
        var limiterOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Group);

        this.deleteKey = this.deleteKey.bind(this);
        this.limiterOptions = limiterOptions;
        parser$3.load(this.limiterOptions, this.defaults, this);
        this.Events = new Events$2(this);
        this.instances = {};
        this.Bottleneck = Bottleneck_1;

        this._startAutoCleanup();

        this.sharedConnection = this.connection != null;

        if (this.connection == null) {
          if (this.limiterOptions.datastore === "redis") {
            this.connection = new RedisConnection$1(Object.assign({}, this.limiterOptions, {
              Events: this.Events
            }));
          } else if (this.limiterOptions.datastore === "ioredis") {
            this.connection = new IORedisConnection$1(Object.assign({}, this.limiterOptions, {
              Events: this.Events
            }));
          }
        }
      }

      _createClass(Group, [{
        key: "key",
        value: function key() {
          var _this7 = this;

          var _key3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";

          var ref;
          return (ref = this.instances[_key3]) != null ? ref : function () {
            var limiter;
            limiter = _this7.instances[_key3] = new _this7.Bottleneck(Object.assign(_this7.limiterOptions, {
              id: "".concat(_this7.id, "-").concat(_key3),
              timeout: _this7.timeout,
              connection: _this7.connection
            }));

            _this7.Events.trigger("created", limiter, _key3);

            return limiter;
          }();
        }
      }, {
        key: "deleteKey",
        value: function () {
          var _deleteKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
            var key,
                deleted,
                instance,
                _args20 = arguments;
            return _regeneratorRuntime.wrap(function _callee20$(_context20) {
              while (1) {
                switch (_context20.prev = _context20.next) {
                  case 0:
                    key = _args20.length > 0 && _args20[0] !== undefined ? _args20[0] : "";
                    instance = this.instances[key];

                    if (!this.connection) {
                      _context20.next = 6;
                      break;
                    }

                    _context20.next = 5;
                    return this.connection.__runCommand__(['del'].concat(_toConsumableArray(Scripts$1.allKeys("".concat(this.id, "-").concat(key)))));

                  case 5:
                    deleted = _context20.sent;

                  case 6:
                    if (!(instance != null)) {
                      _context20.next = 10;
                      break;
                    }

                    delete this.instances[key];
                    _context20.next = 10;
                    return instance.disconnect();

                  case 10:
                    return _context20.abrupt("return", instance != null || deleted > 0);

                  case 11:
                  case "end":
                    return _context20.stop();
                }
              }
            }, _callee20, this);
          }));

          function deleteKey() {
            return _deleteKey.apply(this, arguments);
          }

          return deleteKey;
        }()
      }, {
        key: "limiters",
        value: function limiters() {
          var k, ref, results, v;
          ref = this.instances;
          results = [];

          for (k in ref) {
            v = ref[k];
            results.push({
              key: k,
              limiter: v
            });
          }

          return results;
        }
      }, {
        key: "keys",
        value: function keys() {
          return Object.keys(this.instances);
        }
      }, {
        key: "clusterKeys",
        value: function () {
          var _clusterKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
            var cursor, end, found, i, k, keys, len, next, start, _yield$this$connectio, _yield$this$connectio2;

            return _regeneratorRuntime.wrap(function _callee21$(_context21) {
              while (1) {
                switch (_context21.prev = _context21.next) {
                  case 0:
                    if (!(this.connection == null)) {
                      _context21.next = 2;
                      break;
                    }

                    return _context21.abrupt("return", this.Promise.resolve(this.keys()));

                  case 2:
                    keys = [];
                    cursor = null;
                    start = "b_".concat(this.id, "-").length;
                    end = "_settings".length;

                  case 6:
                    if (!(cursor !== 0)) {
                      _context21.next = 17;
                      break;
                    }

                    _context21.next = 9;
                    return this.connection.__runCommand__(["scan", cursor != null ? cursor : 0, "match", "b_".concat(this.id, "-*_settings"), "count", 10000]);

                  case 9:
                    _yield$this$connectio = _context21.sent;
                    _yield$this$connectio2 = _slicedToArray(_yield$this$connectio, 2);
                    next = _yield$this$connectio2[0];
                    found = _yield$this$connectio2[1];
                    cursor = ~~next;

                    for (i = 0, len = found.length; i < len; i++) {
                      k = found[i];
                      keys.push(k.slice(start, -end));
                    }

                    _context21.next = 6;
                    break;

                  case 17:
                    return _context21.abrupt("return", keys);

                  case 18:
                  case "end":
                    return _context21.stop();
                }
              }
            }, _callee21, this);
          }));

          function clusterKeys() {
            return _clusterKeys.apply(this, arguments);
          }

          return clusterKeys;
        }()
      }, {
        key: "_startAutoCleanup",
        value: function _startAutoCleanup() {
          var _this8 = this;

          var base;
          clearInterval(this.interval);
          return typeof (base = this.interval = setInterval( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
            var e, k, ref, results, time, v;
            return _regeneratorRuntime.wrap(function _callee22$(_context22) {
              while (1) {
                switch (_context22.prev = _context22.next) {
                  case 0:
                    time = Date.now();
                    ref = _this8.instances;
                    results = [];
                    _context22.t0 = _regeneratorRuntime.keys(ref);

                  case 4:
                    if ((_context22.t1 = _context22.t0()).done) {
                      _context22.next = 23;
                      break;
                    }

                    k = _context22.t1.value;
                    v = ref[k];
                    _context22.prev = 7;
                    _context22.next = 10;
                    return v._store.__groupCheck__(time);

                  case 10:
                    if (!_context22.sent) {
                      _context22.next = 14;
                      break;
                    }

                    results.push(_this8.deleteKey(k));
                    _context22.next = 15;
                    break;

                  case 14:
                    results.push(void 0);

                  case 15:
                    _context22.next = 21;
                    break;

                  case 17:
                    _context22.prev = 17;
                    _context22.t2 = _context22["catch"](7);
                    e = _context22.t2;
                    results.push(v.Events.trigger("error", e));

                  case 21:
                    _context22.next = 4;
                    break;

                  case 23:
                    return _context22.abrupt("return", results);

                  case 24:
                  case "end":
                    return _context22.stop();
                }
              }
            }, _callee22, null, [[7, 17]]);
          })), this.timeout / 2)).unref === "function" ? base.unref() : void 0;
        }
      }, {
        key: "updateSettings",
        value: function updateSettings() {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          parser$3.overwrite(options, this.defaults, this);
          parser$3.overwrite(options, options, this.limiterOptions);

          if (options.timeout != null) {
            return this._startAutoCleanup();
          }
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          var flush = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          var ref;

          if (!this.sharedConnection) {
            return (ref = this.connection) != null ? ref.disconnect(flush) : void 0;
          }
        }
      }]);

      return Group;
    }();

    Group.prototype.defaults = {
      timeout: 1000 * 60 * 5,
      connection: null,
      Promise: Promise,
      id: "group-key"
    };
    return Group;
  }.call(commonjsGlobal);

  var Group_1 = Group;
  var Batcher, Events$3, parser$4;
  parser$4 = parser;
  Events$3 = Events_1;

  Batcher = function () {
    var Batcher = /*#__PURE__*/function () {
      function Batcher() {
        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Batcher);

        this.options = options;
        parser$4.load(this.options, this.defaults, this);
        this.Events = new Events$3(this);
        this._arr = [];

        this._resetPromise();

        this._lastFlush = Date.now();
      }

      _createClass(Batcher, [{
        key: "_resetPromise",
        value: function _resetPromise() {
          var _this9 = this;

          return this._promise = new this.Promise(function (res, rej) {
            return _this9._resolve = res;
          });
        }
      }, {
        key: "_flush",
        value: function _flush() {
          clearTimeout(this._timeout);
          this._lastFlush = Date.now();

          this._resolve();

          this.Events.trigger("batch", this._arr);
          this._arr = [];
          return this._resetPromise();
        }
      }, {
        key: "add",
        value: function add(data) {
          var _this10 = this;

          var ret;

          this._arr.push(data);

          ret = this._promise;

          if (this._arr.length === this.maxSize) {
            this._flush();
          } else if (this.maxTime != null && this._arr.length === 1) {
            this._timeout = setTimeout(function () {
              return _this10._flush();
            }, this.maxTime);
          }

          return ret;
        }
      }]);

      return Batcher;
    }();

    Batcher.prototype.defaults = {
      maxTime: null,
      maxSize: null,
      Promise: Promise
    };
    return Batcher;
  }.call(commonjsGlobal);

  var Batcher_1 = Batcher;

  var require$$4$1 = function require$$4$1() {
    return console.log('You must import the full version of Bottleneck in order to use this feature.');
  };

  var require$$8 = getCjsExportFromNamespace(version$2);
  var Bottleneck,
      DEFAULT_PRIORITY$1,
      Events$4,
      Job$1,
      LocalDatastore$1,
      NUM_PRIORITIES$1,
      Queues$1,
      RedisDatastore$1,
      States$1,
      Sync$1,
      parser$5,
      splice = [].splice;
  NUM_PRIORITIES$1 = 10;
  DEFAULT_PRIORITY$1 = 5;
  parser$5 = parser;
  Queues$1 = Queues_1;
  Job$1 = Job_1;
  LocalDatastore$1 = LocalDatastore_1;
  RedisDatastore$1 = require$$4$1;
  Events$4 = Events_1;
  States$1 = States_1;
  Sync$1 = Sync_1;

  Bottleneck = function () {
    var Bottleneck = /*#__PURE__*/function () {
      function Bottleneck() {
        var _this11 = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

        _classCallCheck(this, Bottleneck);

        var storeInstanceOptions, storeOptions;
        this._addToQueue = this._addToQueue.bind(this);

        for (var _len3 = arguments.length, invalid = new Array(_len3 > 1 ? _len3 - 1 : 0), _key4 = 1; _key4 < _len3; _key4++) {
          invalid[_key4 - 1] = arguments[_key4];
        }

        this._validateOptions(options, invalid);

        parser$5.load(options, this.instanceDefaults, this);
        this._queues = new Queues$1(NUM_PRIORITIES$1);
        this._scheduled = {};
        this._states = new States$1(["RECEIVED", "QUEUED", "RUNNING", "EXECUTING"].concat(this.trackDoneStatus ? ["DONE"] : []));
        this._limiter = null;
        this.Events = new Events$4(this);
        this._submitLock = new Sync$1("submit", this.Promise);
        this._registerLock = new Sync$1("register", this.Promise);
        storeOptions = parser$5.load(options, this.storeDefaults, {});

        this._store = function () {
          if (this.datastore === "redis" || this.datastore === "ioredis" || this.connection != null) {
            storeInstanceOptions = parser$5.load(options, this.redisStoreDefaults, {});
            return new RedisDatastore$1(this, storeOptions, storeInstanceOptions);
          } else if (this.datastore === "local") {
            storeInstanceOptions = parser$5.load(options, this.localStoreDefaults, {});
            return new LocalDatastore$1(this, storeOptions, storeInstanceOptions);
          } else {
            throw new Bottleneck.prototype.BottleneckError("Invalid datastore type: ".concat(this.datastore));
          }
        }.call(this);

        this._queues.on("leftzero", function () {
          var ref;
          return (ref = _this11._store.heartbeat) != null ? typeof ref.ref === "function" ? ref.ref() : void 0 : void 0;
        });

        this._queues.on("zero", function () {
          var ref;
          return (ref = _this11._store.heartbeat) != null ? typeof ref.unref === "function" ? ref.unref() : void 0 : void 0;
        });
      }

      _createClass(Bottleneck, [{
        key: "_validateOptions",
        value: function _validateOptions(options, invalid) {
          if (!(options != null && typeof options === "object" && invalid.length === 0)) {
            throw new Bottleneck.prototype.BottleneckError("Bottleneck v2 takes a single object argument. Refer to https://github.com/SGrondin/bottleneck#upgrading-to-v2 if you're upgrading from Bottleneck v1.");
          }
        }
      }, {
        key: "ready",
        value: function ready() {
          return this._store.ready;
        }
      }, {
        key: "clients",
        value: function clients() {
          return this._store.clients;
        }
      }, {
        key: "channel",
        value: function channel() {
          return "b_".concat(this.id);
        }
      }, {
        key: "channel_client",
        value: function channel_client() {
          return "b_".concat(this.id, "_").concat(this._store.clientId);
        }
      }, {
        key: "publish",
        value: function publish(message) {
          return this._store.__publish__(message);
        }
      }, {
        key: "disconnect",
        value: function disconnect() {
          var flush = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
          return this._store.__disconnect__(flush);
        }
      }, {
        key: "chain",
        value: function chain(_limiter) {
          this._limiter = _limiter;
          return this;
        }
      }, {
        key: "queued",
        value: function queued(priority) {
          return this._queues.queued(priority);
        }
      }, {
        key: "clusterQueued",
        value: function clusterQueued() {
          return this._store.__queued__();
        }
      }, {
        key: "empty",
        value: function empty() {
          return this.queued() === 0 && this._submitLock.isEmpty();
        }
      }, {
        key: "running",
        value: function running() {
          return this._store.__running__();
        }
      }, {
        key: "done",
        value: function done() {
          return this._store.__done__();
        }
      }, {
        key: "jobStatus",
        value: function jobStatus(id) {
          return this._states.jobStatus(id);
        }
      }, {
        key: "jobs",
        value: function jobs(status) {
          return this._states.statusJobs(status);
        }
      }, {
        key: "counts",
        value: function counts() {
          return this._states.statusCounts();
        }
      }, {
        key: "_randomIndex",
        value: function _randomIndex() {
          return Math.random().toString(36).slice(2);
        }
      }, {
        key: "check",
        value: function check() {
          var weight = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
          return this._store.__check__(weight);
        }
      }, {
        key: "_clearGlobalState",
        value: function _clearGlobalState(index) {
          if (this._scheduled[index] != null) {
            clearTimeout(this._scheduled[index].expiration);
            delete this._scheduled[index];
            return true;
          } else {
            return false;
          }
        }
      }, {
        key: "_free",
        value: function () {
          var _free2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(index, job, options, eventInfo) {
            var e, running, _yield$this$_store$__;

            return _regeneratorRuntime.wrap(function _callee23$(_context23) {
              while (1) {
                switch (_context23.prev = _context23.next) {
                  case 0:
                    _context23.prev = 0;
                    _context23.next = 3;
                    return this._store.__free__(index, options.weight);

                  case 3:
                    _yield$this$_store$__ = _context23.sent;
                    running = _yield$this$_store$__.running;
                    this.Events.trigger("debug", "Freed ".concat(options.id), eventInfo);

                    if (!(running === 0 && this.empty())) {
                      _context23.next = 8;
                      break;
                    }

                    return _context23.abrupt("return", this.Events.trigger("idle"));

                  case 8:
                    _context23.next = 14;
                    break;

                  case 10:
                    _context23.prev = 10;
                    _context23.t0 = _context23["catch"](0);
                    e = _context23.t0;
                    return _context23.abrupt("return", this.Events.trigger("error", e));

                  case 14:
                  case "end":
                    return _context23.stop();
                }
              }
            }, _callee23, this, [[0, 10]]);
          }));

          function _free(_x25, _x26, _x27, _x28) {
            return _free2.apply(this, arguments);
          }

          return _free;
        }()
      }, {
        key: "_run",
        value: function _run(index, job, wait) {
          var _this12 = this;

          var clearGlobalState, free, run;
          job.doRun();
          clearGlobalState = this._clearGlobalState.bind(this, index);
          run = this._run.bind(this, index, job);
          free = this._free.bind(this, index, job);
          return this._scheduled[index] = {
            timeout: setTimeout(function () {
              return job.doExecute(_this12._limiter, clearGlobalState, run, free);
            }, wait),
            expiration: job.options.expiration != null ? setTimeout(function () {
              return job.doExpire(clearGlobalState, run, free);
            }, wait + job.options.expiration) : void 0,
            job: job
          };
        }
      }, {
        key: "_drainOne",
        value: function _drainOne(capacity) {
          var _this13 = this;

          return this._registerLock.schedule(function () {
            var args, index, next, options, queue;

            if (_this13.queued() === 0) {
              return _this13.Promise.resolve(null);
            }

            queue = _this13._queues.getFirst();

            var _next = next = queue.first();

            options = _next.options;
            args = _next.args;

            if (capacity != null && options.weight > capacity) {
              return _this13.Promise.resolve(null);
            }

            _this13.Events.trigger("debug", "Draining ".concat(options.id), {
              args: args,
              options: options
            });

            index = _this13._randomIndex();
            return _this13._store.__register__(index, options.weight, options.expiration).then(function (_ref5) {
              var success = _ref5.success,
                  wait = _ref5.wait,
                  reservoir = _ref5.reservoir;
              var empty;

              _this13.Events.trigger("debug", "Drained ".concat(options.id), {
                success: success,
                args: args,
                options: options
              });

              if (success) {
                queue.shift();
                empty = _this13.empty();

                if (empty) {
                  _this13.Events.trigger("empty");
                }

                if (reservoir === 0) {
                  _this13.Events.trigger("depleted", empty);
                }

                _this13._run(index, next, wait);

                return _this13.Promise.resolve(options.weight);
              } else {
                return _this13.Promise.resolve(null);
              }
            });
          });
        }
      }, {
        key: "_drainAll",
        value: function _drainAll(capacity) {
          var _this14 = this;

          var total = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
          return this._drainOne(capacity).then(function (drained) {
            var newCapacity;

            if (drained != null) {
              newCapacity = capacity != null ? capacity - drained : capacity;
              return _this14._drainAll(newCapacity, total + drained);
            } else {
              return _this14.Promise.resolve(total);
            }
          }).catch(function (e) {
            return _this14.Events.trigger("error", e);
          });
        }
      }, {
        key: "_dropAllQueued",
        value: function _dropAllQueued(message) {
          return this._queues.shiftAll(function (job) {
            return job.doDrop({
              message: message
            });
          });
        }
      }, {
        key: "stop",
        value: function stop() {
          var _this15 = this;

          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var done, waitForExecuting;
          options = parser$5.load(options, this.stopDefaults);

          waitForExecuting = function waitForExecuting(at) {
            var finished;

            finished = function finished() {
              var counts;
              counts = _this15._states.counts;
              return counts[0] + counts[1] + counts[2] + counts[3] === at;
            };

            return new _this15.Promise(function (resolve, reject) {
              if (finished()) {
                return resolve();
              } else {
                return _this15.on("done", function () {
                  if (finished()) {
                    _this15.removeAllListeners("done");

                    return resolve();
                  }
                });
              }
            });
          };

          done = options.dropWaitingJobs ? (this._run = function (index, next) {
            return next.doDrop({
              message: options.dropErrorMessage
            });
          }, this._drainOne = function () {
            return _this15.Promise.resolve(null);
          }, this._registerLock.schedule(function () {
            return _this15._submitLock.schedule(function () {
              var k, ref, v;
              ref = _this15._scheduled;

              for (k in ref) {
                v = ref[k];

                if (_this15.jobStatus(v.job.options.id) === "RUNNING") {
                  clearTimeout(v.timeout);
                  clearTimeout(v.expiration);
                  v.job.doDrop({
                    message: options.dropErrorMessage
                  });
                }
              }

              _this15._dropAllQueued(options.dropErrorMessage);

              return waitForExecuting(0);
            });
          })) : this.schedule({
            priority: NUM_PRIORITIES$1 - 1,
            weight: 0
          }, function () {
            return waitForExecuting(1);
          });

          this._receive = function (job) {
            return job._reject(new Bottleneck.prototype.BottleneckError(options.enqueueErrorMessage));
          };

          this.stop = function () {
            return _this15.Promise.reject(new Bottleneck.prototype.BottleneckError("stop() has already been called"));
          };

          return done;
        }
      }, {
        key: "_addToQueue",
        value: function () {
          var _addToQueue2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(job) {
            var args, blocked, error, options, reachedHWM, shifted, strategy, _yield$this$_store$__2;

            return _regeneratorRuntime.wrap(function _callee24$(_context24) {
              while (1) {
                switch (_context24.prev = _context24.next) {
                  case 0:
                    args = job.args;
                    options = job.options;
                    _context24.prev = 2;
                    _context24.next = 5;
                    return this._store.__submit__(this.queued(), options.weight);

                  case 5:
                    _yield$this$_store$__2 = _context24.sent;
                    reachedHWM = _yield$this$_store$__2.reachedHWM;
                    blocked = _yield$this$_store$__2.blocked;
                    strategy = _yield$this$_store$__2.strategy;
                    _context24.next = 17;
                    break;

                  case 11:
                    _context24.prev = 11;
                    _context24.t0 = _context24["catch"](2);
                    error = _context24.t0;
                    this.Events.trigger("debug", "Could not queue ".concat(options.id), {
                      args: args,
                      options: options,
                      error: error
                    });
                    job.doDrop({
                      error: error
                    });
                    return _context24.abrupt("return", false);

                  case 17:
                    if (!blocked) {
                      _context24.next = 22;
                      break;
                    }

                    job.doDrop();
                    return _context24.abrupt("return", true);

                  case 22:
                    if (!reachedHWM) {
                      _context24.next = 28;
                      break;
                    }

                    shifted = strategy === Bottleneck.prototype.strategy.LEAK ? this._queues.shiftLastFrom(options.priority) : strategy === Bottleneck.prototype.strategy.OVERFLOW_PRIORITY ? this._queues.shiftLastFrom(options.priority + 1) : strategy === Bottleneck.prototype.strategy.OVERFLOW ? job : void 0;

                    if (shifted != null) {
                      shifted.doDrop();
                    }

                    if (!(shifted == null || strategy === Bottleneck.prototype.strategy.OVERFLOW)) {
                      _context24.next = 28;
                      break;
                    }

                    if (shifted == null) {
                      job.doDrop();
                    }

                    return _context24.abrupt("return", reachedHWM);

                  case 28:
                    job.doQueue(reachedHWM, blocked);

                    this._queues.push(job);

                    _context24.next = 32;
                    return this._drainAll();

                  case 32:
                    return _context24.abrupt("return", reachedHWM);

                  case 33:
                  case "end":
                    return _context24.stop();
                }
              }
            }, _callee24, this, [[2, 11]]);
          }));

          function _addToQueue(_x29) {
            return _addToQueue2.apply(this, arguments);
          }

          return _addToQueue;
        }()
      }, {
        key: "_receive",
        value: function _receive(job) {
          if (this._states.jobStatus(job.options.id) != null) {
            job._reject(new Bottleneck.prototype.BottleneckError("A job with the same id already exists (id=".concat(job.options.id, ")")));

            return false;
          } else {
            job.doReceive();
            return this._submitLock.schedule(this._addToQueue, job);
          }
        }
      }, {
        key: "submit",
        value: function submit() {
          var _this16 = this;

          for (var _len4 = arguments.length, args = new Array(_len4), _key5 = 0; _key5 < _len4; _key5++) {
            args[_key5] = arguments[_key5];
          }

          var cb, fn, job, options, ref, ref1, task;

          if (typeof args[0] === "function") {
            var _ref6, _ref7, _splice$call, _splice$call2;

            ref = args, (_ref6 = ref, _ref7 = _toArray(_ref6), fn = _ref7[0], args = _ref7.slice(1)), (_splice$call = splice.call(args, -1), _splice$call2 = _slicedToArray(_splice$call, 1), cb = _splice$call2[0]);
            options = parser$5.load({}, this.jobDefaults);
          } else {
            var _ref8, _ref9, _splice$call3, _splice$call4;

            ref1 = args, (_ref8 = ref1, _ref9 = _toArray(_ref8), options = _ref9[0], fn = _ref9[1], args = _ref9.slice(2)), (_splice$call3 = splice.call(args, -1), _splice$call4 = _slicedToArray(_splice$call3, 1), cb = _splice$call4[0]);
            options = parser$5.load(options, this.jobDefaults);
          }

          task = function task() {
            for (var _len5 = arguments.length, args = new Array(_len5), _key6 = 0; _key6 < _len5; _key6++) {
              args[_key6] = arguments[_key6];
            }

            return new _this16.Promise(function (resolve, reject) {
              return fn.apply(void 0, args.concat([function () {
                for (var _len6 = arguments.length, args = new Array(_len6), _key7 = 0; _key7 < _len6; _key7++) {
                  args[_key7] = arguments[_key7];
                }

                return (args[0] != null ? reject : resolve)(args);
              }]));
            });
          };

          job = new Job$1(task, args, options, this.jobDefaults, this.rejectOnDrop, this.Events, this._states, this.Promise);
          job.promise.then(function (args) {
            return typeof cb === "function" ? cb.apply(void 0, _toConsumableArray(args)) : void 0;
          }).catch(function (args) {
            if (Array.isArray(args)) {
              return typeof cb === "function" ? cb.apply(void 0, _toConsumableArray(args)) : void 0;
            } else {
              return typeof cb === "function" ? cb(args) : void 0;
            }
          });
          return this._receive(job);
        }
      }, {
        key: "schedule",
        value: function schedule() {
          for (var _len7 = arguments.length, args = new Array(_len7), _key8 = 0; _key8 < _len7; _key8++) {
            args[_key8] = arguments[_key8];
          }

          var job, options, task;

          if (typeof args[0] === "function") {
            var _args25 = args;

            var _args26 = _toArray(_args25);

            task = _args26[0];
            args = _args26.slice(1);
            options = {};
          } else {
            var _args27 = args;

            var _args28 = _toArray(_args27);

            options = _args28[0];
            task = _args28[1];
            args = _args28.slice(2);
          }

          job = new Job$1(task, args, options, this.jobDefaults, this.rejectOnDrop, this.Events, this._states, this.Promise);

          this._receive(job);

          return job.promise;
        }
      }, {
        key: "wrap",
        value: function wrap(fn) {
          var schedule, wrapped;
          schedule = this.schedule.bind(this);

          wrapped = function wrapped() {
            for (var _len8 = arguments.length, args = new Array(_len8), _key9 = 0; _key9 < _len8; _key9++) {
              args[_key9] = arguments[_key9];
            }

            return schedule.apply(void 0, [fn.bind(this)].concat(args));
          };

          wrapped.withOptions = function (options) {
            for (var _len9 = arguments.length, args = new Array(_len9 > 1 ? _len9 - 1 : 0), _key10 = 1; _key10 < _len9; _key10++) {
              args[_key10 - 1] = arguments[_key10];
            }

            return schedule.apply(void 0, [options, fn].concat(args));
          };

          return wrapped;
        }
      }, {
        key: "updateSettings",
        value: function () {
          var _updateSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
            var options,
                _args29 = arguments;
            return _regeneratorRuntime.wrap(function _callee25$(_context25) {
              while (1) {
                switch (_context25.prev = _context25.next) {
                  case 0:
                    options = _args29.length > 0 && _args29[0] !== undefined ? _args29[0] : {};
                    _context25.next = 3;
                    return this._store.__updateSettings__(parser$5.overwrite(options, this.storeDefaults));

                  case 3:
                    parser$5.overwrite(options, this.instanceDefaults, this);
                    return _context25.abrupt("return", this);

                  case 5:
                  case "end":
                    return _context25.stop();
                }
              }
            }, _callee25, this);
          }));

          function updateSettings() {
            return _updateSettings.apply(this, arguments);
          }

          return updateSettings;
        }()
      }, {
        key: "currentReservoir",
        value: function currentReservoir() {
          return this._store.__currentReservoir__();
        }
      }, {
        key: "incrementReservoir",
        value: function incrementReservoir() {
          var incr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
          return this._store.__incrementReservoir__(incr);
        }
      }]);

      return Bottleneck;
    }();

    Bottleneck.default = Bottleneck;
    Bottleneck.Events = Events$4;
    Bottleneck.version = Bottleneck.prototype.version = require$$8.version;
    Bottleneck.strategy = Bottleneck.prototype.strategy = {
      LEAK: 1,
      OVERFLOW: 2,
      OVERFLOW_PRIORITY: 4,
      BLOCK: 3
    };
    Bottleneck.BottleneckError = Bottleneck.prototype.BottleneckError = BottleneckError_1;
    Bottleneck.Group = Bottleneck.prototype.Group = Group_1;
    Bottleneck.RedisConnection = Bottleneck.prototype.RedisConnection = require$$2;
    Bottleneck.IORedisConnection = Bottleneck.prototype.IORedisConnection = require$$3;
    Bottleneck.Batcher = Bottleneck.prototype.Batcher = Batcher_1;
    Bottleneck.prototype.jobDefaults = {
      priority: DEFAULT_PRIORITY$1,
      weight: 1,
      expiration: null,
      id: "<no-id>"
    };
    Bottleneck.prototype.storeDefaults = {
      maxConcurrent: null,
      minTime: 0,
      highWater: null,
      strategy: Bottleneck.prototype.strategy.LEAK,
      penalty: null,
      reservoir: null,
      reservoirRefreshInterval: null,
      reservoirRefreshAmount: null,
      reservoirIncreaseInterval: null,
      reservoirIncreaseAmount: null,
      reservoirIncreaseMaximum: null
    };
    Bottleneck.prototype.localStoreDefaults = {
      Promise: Promise,
      timeout: null,
      heartbeatInterval: 250
    };
    Bottleneck.prototype.redisStoreDefaults = {
      Promise: Promise,
      timeout: null,
      heartbeatInterval: 5000,
      clientTimeout: 10000,
      Redis: null,
      clientOptions: {},
      clusterNodes: null,
      clearDatastore: false,
      connection: null
    };
    Bottleneck.prototype.instanceDefaults = {
      datastore: "local",
      connection: null,
      id: "<no-id>",
      rejectOnDrop: true,
      trackDoneStatus: false,
      Promise: Promise
    };
    Bottleneck.prototype.stopDefaults = {
      enqueueErrorMessage: "This limiter has been stopped and cannot accept new jobs.",
      dropWaitingJobs: true,
      dropErrorMessage: "This limiter has been stopped."
    };
    return Bottleneck;
  }.call(commonjsGlobal);

  var Bottleneck_1 = Bottleneck;
  var lib = Bottleneck_1;
  return lib;
});